// extracted by mini-css-extract-plugin
export default {"container":"Privacy_container__76hXB","privacySection":"Privacy_privacySection__ZKNeZ"};